import { UploadWorkbookDialogValues } from '../components/UploadWorkbookDialog';

export namespace UploadWorkbookActionsTypes {
  export const START = 'UPLOAD_WORKBOOK_START';
  export const IN_PROGRESS = 'UPLOAD_WORKBOOK_IN_PROGRESS';
  export const COMPLETE = 'UPLOAD_WORKBOOK_COMPLETE';
  export const REMOVE_UPLOAD = 'REMOVE_WORKBOOK_UPLOAD';
}

export interface UploadWorkbookStartAction {
  readonly type: typeof UploadWorkbookActionsTypes.START;
  readonly data: UploadWorkbookDialogValues;
  readonly overwrite: boolean;
}

export interface UploadInProgressAction {
  readonly type: typeof UploadWorkbookActionsTypes.IN_PROGRESS | typeof UploadWorkbookActionsTypes.COMPLETE;
  readonly id: string;
  readonly bytesUploaded?: number;
  readonly totalBytes?: number;
  readonly filename?: string;
}

export interface UploadWorkbookRemoveAction {
  readonly type: typeof UploadWorkbookActionsTypes.REMOVE_UPLOAD;
  readonly id: string;
}

export type UploadWorkbookActions = UploadWorkbookStartAction | UploadInProgressAction | UploadWorkbookRemoveAction;

/*
 * action creators
 */

export function requestUploadWorkbookAction(args: Omit<UploadWorkbookStartAction, 'type'>): UploadWorkbookStartAction {
  return {
    type: UploadWorkbookActionsTypes.START,
    ...args
  };
}

export function requestUploadInProgressAction(args: Omit<UploadInProgressAction, 'type'>): UploadInProgressAction {
  return {
    type: UploadWorkbookActionsTypes.IN_PROGRESS,
    ...args
  };
}

export function requestUploadCompleteAction(args: Omit<UploadInProgressAction, 'type'>): UploadInProgressAction {
  return {
    type: UploadWorkbookActionsTypes.COMPLETE,
    ...args
  };
}

export function removeUploadByIdAction(args: Omit<UploadWorkbookRemoveAction, 'type'>): UploadWorkbookRemoveAction {
  return {
    type: UploadWorkbookActionsTypes.REMOVE_UPLOAD,
    ...args
  };
}
